// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.avo__alert.show {
  opacity: 1;
  z-index: 20;
  background-color: rgba(235, 240, 246, 0.8);
  animation: fadeInBackdrop 0.2s ease;
}
.avo__alert.hide {
  opacity: 0;
  z-index: -1;
  pointer-events: none;
  animation: fadeOutBackdrop 0.2s ease;
}
.avo__alert .dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.avo__alert .dialog.show {
  animation: fadeIn 0.3s ease;
}
.avo__alert .dialog.hide {
  animation: fadeOut 0.3s ease;
}
.avo__alert .content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 16px;
  border-radius: 16px;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  max-height: 50%;
  overflow: auto;
}
.avo__alert .content img {
  width: 48px;
  height: 48px;
  margin-top: 12px;
}
.avo__alert .content .title {
  margin-top: 12px;
  font-size: 14px;
  font-family: "OpenSans-Medium";
}
.avo__alert .content .message {
  margin-top: 8px;
  font-size: 13px;
  font-family: "OpenSans-Regular";
  white-space: pre-wrap;
}
.avo__alert .content .message.no-footer {
  margin-bottom: 12px;
}
.avo__alert .content .footer {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

@keyframes fadeInBackdrop {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOutBackdrop {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/commons/alert/alert.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,wDAAA;EACA,0BAAA;AADJ;AAGI;EACI,UAAA;EACA,WAAA;EACA,0CAAA;EACA,mCAAA;AADR;AAII;EACI,UAAA;EACA,WAAA;EACA,oBAAA;EACA,oCAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,wDAAA;EACA,0BAAA;AAHR;AAKQ;EACI,2BAAA;AAHZ;AAMQ;EACI,4BAAA;AAJZ;AAQI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kFAAA;EAEA,eAAA;EACA,cAAA;AAPR;AASQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AAPZ;AAUQ;EACI,gBAAA;EACA,eAAA;EACA,8BAAA;AARZ;AAWQ;EACI,eAAA;EACA,eAAA;EACA,+BAAA;EACA,qBAAA;AATZ;AAWY;EACI,mBAAA;AAThB;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAXZ;;AAgBA;EACI;IACI,UAAA;EAbN;EAeE;IACI,UAAA;EAbN;AACF;AAgBA;EACI;IACI,UAAA;EAdN;EAgBE;IACI,UAAA;EAdN;AACF;AAiBA;EACI;IACI,UAAA;IACA,sBAAA;EAfN;EAiBE;IACI,UAAA;IACA,mBAAA;EAfN;AACF;AAkBA;EACI;IACI,UAAA;IACA,mBAAA;EAhBN;EAkBE;IACI,UAAA;IACA,sBAAA;EAhBN;AACF","sourcesContent":["@import '../../../styles/color';\n\n.avo__alert {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transition-property: all;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transition-duration: 150ms;\n\n    &.show {\n        opacity: 1;\n        z-index: 20;\n        background-color: rgb(235, 240, 246, 0.8);\n        animation: fadeInBackdrop 0.2s ease;\n    }\n\n    &.hide {\n        opacity: 0;\n        z-index: -1;\n        pointer-events: none;\n        animation: fadeOutBackdrop 0.2s ease;\n    }\n\n    .dialog {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        width: 100%;\n        max-width: 400px;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 16px;\n        transition-property: all;\n        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n        transition-duration: 150ms;\n\n        &.show {\n            animation: fadeIn 0.3s ease;\n        }\n\n        &.hide {\n            animation: fadeOut 0.3s ease;\n        }\n    }\n\n    .content {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        background-color: white;\n        padding: 16px;\n        border-radius: 16px;\n        width: 100%;\n        box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),\n            0 4px 6px -4px rgb(0 0 0 / 0.1);\n        max-height: 50%;\n        overflow: auto;\n\n        img {\n            width: 48px;\n            height: 48px;\n            margin-top: 12px;\n        }\n\n        .title {\n            margin-top: 12px;\n            font-size: 14px;\n            font-family: 'OpenSans-Medium';\n        }\n\n        .message {\n            margin-top: 8px;\n            font-size: 13px;\n            font-family: 'OpenSans-Regular';\n            white-space: pre-wrap;\n\n            &.no-footer {\n                margin-bottom: 12px;\n            }\n        }\n\n        .footer {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            margin-top: 24px;\n        }\n    }\n}\n\n@keyframes fadeInBackdrop {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeOutBackdrop {\n    from {\n        opacity: 1;\n    }\n    to {\n        opacity: 0;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.95);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1;\n        transform: scale(1);\n    }\n    to {\n        opacity: 0;\n        transform: scale(0.95);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
